import { Link } from "react-router-dom";

export const NotListedCTA = ({ question, cta, to, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="group mt-6 flex w-full max-w-2xl items-center justify-between gap-4 border-l-4 border-yellow-500 bg-gray-50 px-5 py-4 transition-colors hover:bg-[#0A0A0A]"
  >
    <span className="text-sm font-semibold text-gray-950 transition-colors group-hover:text-white">{question}</span>
    <span className="flex shrink-0 items-center gap-2 font-mono-tech text-[11px] font-bold uppercase tracking-[0.18em] text-gray-950 transition-colors group-hover:text-yellow-500">
      {cta.replace("→", "").trim()}
      <span className="transition-transform duration-150 group-hover:translate-x-1">→</span>
    </span>
  </Link>
);
